import { CheckboxOptionType } from 'antd';
import { useTranslation } from 'react-i18next';

export const useReasonForLeavingOptions = (): Array<CheckboxOptionType> => {
    const { t } = useTranslation();

    const staticReasonOptions: Array<CheckboxOptionType> = [
        {
            value: 'higher pay',
            label: t('Components.InterviewComponents.ReasonForLeaving.higher_pay_option_label'),
        },
        {
            value: 'improved work/life balance',
            label: t('Components.InterviewComponents.ReasonForLeaving.work_life_balance_option_label'),
        },
        {
            value: 'returning to school',
            label: t('Components.InterviewComponents.ReasonForLeaving.returning_to_school_option_label'),
        },
        {
            value: 'closer to home',
            label: t('Components.InterviewComponents.ReasonForLeaving.closer_to_home_option_label'),
        },
        {
            value: 'better benefits',
            label: t('Components.InterviewComponents.ReasonForLeaving.better_benefits_option_label'),
        },
        {
            value: 'career change',
            label: t('Components.InterviewComponents.ReasonForLeaving.career_change_option_label'),
        },
        {
            value: 'child care',
            label: t('Components.InterviewComponents.ReasonForLeaving.child_care_option_label'),
        },
        {
            value: 'commute/transportation',
            label: t('Components.InterviewComponents.ReasonForLeaving.commute_transportation_option_label'),
        },
        {
            value: 'better career opportunity',
            label: t('Components.InterviewComponents.ReasonForLeaving.better_career_opportunity_option_label'),
        },
        {
            value: 'personal reasons',
            label: t('Components.InterviewComponents.ReasonForLeaving.personal_reasons_option_label'),
        },
    ];

    return staticReasonOptions;
};